export default __webpack_public_path__ + "static/media/330_business03-it-web.69702bbc.png";